// extracted by mini-css-extract-plugin
export default {"incut":"UcEgrHIh","mobile":"mobile","icon":"_ot_jm0_"};